export function openModal() {
  if (typeof gon === "undefined") return;

  let securityModal = null;
  let collectionModal = null;

  if(gon.loggedIn) {
    if(gon.planCode === "free") {
      securityModal = "#upgrade-plan-modal";
    } else {
      // This has a slug appended because the modal is included for each 'card' or 'list' item.
      // But I don't see a way to trigger it opening.
      let orgpath = /^\/collections\/([^\/]+)\//;
      let match = orgpath.exec(location.pathname)
      securityModal = match ? `#security-settings-modal-${match[1]}` : "[id^=security-settings-modal]";
    }

    collectionModal = "#add-to-collection";
  }

  const params = new URL(window.location.href).searchParams;

  let paramMap = {
    show_share: securityModal,
    show_embed: "#shareModal",
    show_sharing: "#shareModal",
    show_collection: collectionModal,
  };

  for (let [p, id] of Object.entries(paramMap)) {
    if (params.get(p) && id !== null) {
      setTimeout(function () {
        if (p === "show_collection") {
          $(id)[0].click();
        } else {
          $(id).modal();
        }
      }, 0);
      break;
    }
  }
}

export default { openModal };
